import TextInput from 'snippets/form/text-input/text-input'
import CheckboxInput from 'snippets/form/checkbox-input/checkbox-input'
import LoaderSpin from 'snippets/loader-spin/loader-spin'
import ProductBackInStockCard from 'snippets/product/product-back-in-stock/product-back-in-stock-card'

function ProductBackInStockContent({ formBIS, product, isLoading, message }) {
  return (
    <div className="[&_.notice-main]:!w-full">
      <ProductBackInStockCard product={product} />
      <div className="p-5">
        <p className="text-xs text-neutral-700 mb-5">{translate.product.notifyMeDescription}</p>
        <form ref={formBIS} id="product-back-in-stock-form" className="flex flex-wrap items-start gap-5">
          <TextInput
            name="email"
            type="email"
            classWrap="flex-1"
            autocomplete
            id="product-notify-input"
            placeholder={translate.product.notifyMeEmailLabel}
            required
            showSymbol={false}
          />
          <CheckboxInput
            name="marketing"
            value="accept-marketing"
            classWrap="w-full"
            label={translate.product.notifyMeMarketingLabel}
          />
          <button type="submit" className="button button-primary flex w-full justify-center">
            {isLoading ? <LoaderSpin size={4} /> : translate.product.notifyMeButtonText}
          </button>
          {message}
        </form>
      </div>
    </div>
  )
}

export default ProductBackInStockContent
